import { EMPTY_LIST } from '../../../../../constants/common'
import { toFlatSelectItem, toFlatSelectItems } from '../../../../Flat'
import {
  EMAIL_RECIPIENTS_BUILDING_FIELD_NAME,
  EMAIL_RECIPIENTS_FLAT_FIELD_NAME,
} from '../EmailRecipientsFilterModal.constants'

function toFlatWithBuildingSelectItem(item) {
  return {
    ...toFlatSelectItem(item),
    additionalData: item.building.title,
    building: item.building,
  }
}

export function toFlatWithBuildingSelectItems(items) {
  return toFlatSelectItems(items, toFlatWithBuildingSelectItem)
}

export function filterFlatOptions({
  [EMAIL_RECIPIENTS_BUILDING_FIELD_NAME]: buildings = EMPTY_LIST,
  [EMAIL_RECIPIENTS_FLAT_FIELD_NAME]: flats = EMPTY_LIST,
}) {
  const buildingIds = buildings.map(building => building.value)

  return flats.filter(flat => buildingIds.includes(flat.building.id))
}
